import '@lottiefiles/lottie-player';

export default class Lottie {
	constructor(el) {
		this.el = el;
		this.load();
	}

	load() {
		this.el.load(this.el.dataset.src);
	}

	static init() {
		document.addEventListener('bless', (e) => {
			const lotties = e.target.querySelectorAll('lottie-player');

			lotties.forEach((el) => {
				new Lottie(el);
			});
		});
	}
}
